import { render } from "./CourseList.component.vue?vue&type=template&id=718f7e68&scoped=true&ts=true"
import script from "./CourseList.component.vue?vue&type=script&lang=ts"
export * from "./CourseList.component.vue?vue&type=script&lang=ts"

import "./CourseList.component.vue?vue&type=style&index=0&id=718f7e68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718f7e68"]])

export default __exports__